import { Roles, SmtpKeys } from '@/common/constants';

/**
 * Returns true if any of the given option codes is set to a truthy value on the
 * company_options, regardless of whether the source is still in its original
 * array form (as received from the backend) or has already been mutated into
 * the object/map form produced by App.vue's setCompanyOptions() for the
 * currently-selected company.
 *
 * @param {Array|Object|null|undefined} companyOptions
 * @param {string[]} optionCodes
 * @returns {boolean}
 */
export const hasCompanyOptionValue = (companyOptions, optionCodes) => {
  if (!companyOptions) return false;
  if (Array.isArray(companyOptions)) {
    return companyOptions.some(opt => optionCodes.includes(opt.option_code) && opt.value);
  }
  return optionCodes.some(code => companyOptions[code]?.value);
};

export const getCompanyOptionValue = (companyOptions, optionCode) => {
  if (!companyOptions) return undefined;
  if (Array.isArray(companyOptions)) {
    return companyOptions.find(opt => opt.option_code === optionCode)?.value;
  }
  return companyOptions[optionCode]?.value;
};

/**
 * True when the student caring email stats apply to the caller: Supervisor, Company admin
 * and MSP need a current company without custom SMTP options, or (MSP only) a child company
 * without them. The other roles always qualify.
 *
 * @param {Object} profile $profile
 * @param {Object} company $company, with company_options in object form
 * @returns {boolean}
 */
export const hasDefaultSmtp = (profile, company) => {
  const customSmtp = profile.hasRoles(Roles.Supervisor, Roles.CompanyAdmin, Roles.MSP) &&
    SmtpKeys.some(key => !!company.company_options[key]?.value);

  const childPlainSettings = profile.hasRoles(Roles.MSP) &&
    profile.companies.filter(c => {
      if (company.company_id == c.company_id) return false;

      const hasSmtpOption = hasCompanyOptionValue(c.company_options, SmtpKeys);

      return c.created_by_company?.uuid && !hasSmtpOption;
    });

  return childPlainSettings?.length > 0 || !customSmtp;
};
